import script from "./DirectPurchaseDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./DirectPurchaseDetail.vue?vue&type=script&setup=true&lang=js"

import "./DirectPurchaseDetail.vue?vue&type=style&index=0&id=7784f698&scoped=true&lang=css"
import "./DirectPurchaseDetail.vue?vue&type=style&index=1&id=7784f698&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7784f698"]])

export default __exports__